
import { fetchJson } from 'helpers/http';
type LivePreviewAttributes = {
    live_preview_attributes: string;
};
export const getLivePreviewAttrs = async (sku: string ): Promise<LivePreviewAttributes> => {
    const path = `${process.env.GATSBY_MAGENTO_API_BASE_URL}/au/product/${sku}/attributes/live_preview_attributes`;
    return await fetchJson(path) as LivePreviewAttributes;
};

export const generateLivePreviewUrl = (baseMediaUrl: string, sku: string, livePreviewAttributes: string, productAttributes: { [key: string]: string; }, defaultProductImage: string): string => {
    let url = baseMediaUrl + '/' + sku;
    const splitAttrs = livePreviewAttributes.split(',');
    const urlAttrs = [];
  
    splitAttrs.forEach(attr => {
      //Check for separate possible attrs such as fabric_color and/or leather_color which will come in as 'fabric_color|leather_color'
      if(attr.includes('|')) {
        attr.split('|').forEach(splitAttr => {
          if(productAttributes[splitAttr]) {
            urlAttrs.push(productAttributes[splitAttr]);
          }
        });
      } else {
        urlAttrs.push(productAttributes[attr]);
      }
    });
  
    urlAttrs.forEach(attr => {
      url = `${url}-${attr}`;
    });

    return url.includes('undefined') ? defaultProductImage : `${url}.jpg`;
  };
  